export enum ActionsEnum {
  yes = 'Yes',
  no = 'No',
  enable = 'enable',
  disable = 'disable',
  success = 'Success',
  fail = 'Fail',
}
